import React from 'react';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import { Box, Text } from '@landtrustinc/design-system';

const InquirySidebarEyebrow = ({ messageId }) => (
  <Box mb="var(--spacing-3)">
    <Text as="p" size="xs" fontWeight="bold" uppercase color="var(--color-hunter-500)">
      <FormattedMessage id={messageId} />
    </Text>
  </Box>
);

InquirySidebarEyebrow.propTypes = {
  messageId: string.isRequired,
};

export default InquirySidebarEyebrow;
